"use strict";

// Native scrolling keeps the original review cards and accessible arrow buttons.
const reviewSliders = document.querySelectorAll(".jannis-native .review-slider");
if (reviewSliders.length !== 1) {
  throw new Error("Advertorial reviews: expected one review slider.");
}
for (const slider of reviewSliders) {
  const mask = slider.querySelector(".mask");
  const previous = slider.querySelector(".w-slider-arrow-left");
  const next = slider.querySelector(".w-slider-arrow-right");
  const slides = slider.querySelectorAll(".w-slide");
  if (!mask || !previous || !next || slides.length < 2) {
    throw new Error("Advertorial reviews: missing review cards or navigation controls.");
  }
  const update = () => {
    const maximum = mask.scrollWidth - mask.clientWidth;
    previous.hidden = next.hidden = maximum <= 1;
    previous.disabled = mask.scrollLeft <= 1;
    next.disabled = mask.scrollLeft >= maximum - 1;
  };
  const move = direction => {
    const step = slides[1].offsetLeft - slides[0].offsetLeft;
    if (step <= 0) throw new Error("Advertorial reviews: invalid card spacing.");
    mask.scrollBy({ left: direction * step });
  };
  previous.addEventListener("click", () => move(-1));
  next.addEventListener("click", () => move(1));
  mask.addEventListener("scroll", update, { passive: true });
  new ResizeObserver(update).observe(mask);
  update();
}
